import { IUser } from "../models/IUser";
import { makeAutoObservable } from "mobx";
import AuthService from "../services/AuthService";
import ShopService from "../services/ShopService";
import DonateService from "../services/DonateService";
import UserService from "../services/UserService";
import axios from "axios";
import { AuthResponse } from "../models/response/AuthResponse";
import { API_URL } from "../http";
import config from '../config.json';
import { DepositBonuses_Response } from "../models/response/DepositBonuses_Response";

export default class Store {
    backendURL = config.backendURL;

    resizeImg = (filename:string, size:number = 512) => {
        const resizeURL = `https://resize.rustylifes.com/resize`;
        return resizeURL + '?filename=' + filename + '&size=' + size;
    }

    user = {} as IUser;
    isAuth = false;
    isLoaded = false;

    donateModalOpen = false;
    donateAmount = 500;

    isServersLoaded = false;
    servers = [] as any;

    isStorageLoaded = false;
    storage = [] as any;

    isTransactionsLoaded = false;
    transactions = [] as any;

    isDepositBonusesLoaded = false;
    depositBonuses: Array<DepositBonuses_Response> = [];

    isKitsLoaded = false;
    kits = [] as any;

    isProductsLoaded = false;
    productGroups = [] as any;
    products = [] as any;

    constructor() {
        makeAutoObservable(this);
    }

    setAuth(bool: boolean) {
        console.log('setauth:',bool)
        this.isAuth = bool;
    }
    setUser(user: IUser) {
        this.user = user;
    }
    setLoaded(bool: boolean) {
        console.log('Loaded:',bool)
        this.isLoaded = bool;
    }

    setDonateModalOpen(bool: boolean) {
        this.donateModalOpen = bool;
    }
    setDonateAmount(amount: number) {
        this.donateAmount = amount;
    }

    setServers(servers: {}) {
        this.servers = servers;
    }
    setServersLoaded(bool: boolean) {
        this.isServersLoaded = bool;
    }
    setStorage(storage: {}) {
        this.storage = storage;
    }
    setStorageLoaded(bool: boolean) {
        this.isStorageLoaded = bool;
    }
    setTransactions(tx: {}) {
        this.transactions = tx;
    }
    setTransactionsLoaded(bool: boolean) {
        this.isTransactionsLoaded = bool;
    }
    setDepositBonuses(depositBonuses: any) {
        this.depositBonuses = depositBonuses;
    }
    setDepositBonusesLoaded(bool: boolean) {
        this.isDepositBonusesLoaded = bool;
    }
    setKits(kits: any) {
        this.kits = kits;
    }
    setKitsLoaded(bool: boolean) {
        this.isKitsLoaded = bool;
    }
    setProducts(products: {}) {
        this.products = products;
    }
    setProductGroups(productGroups: {}) {
        this.productGroups = productGroups;
    }
    setProductsLoaded(bool: boolean) {
        this.isProductsLoaded = bool;
    }

    login() {
        window.location.href = `${this.backendURL}/api/auth`
    }

    async logout() {
        try {
            await AuthService.logout();
            localStorage.removeItem('token');
            this.setAuth(false);
            this.setUser({} as IUser);
        } catch(e:any) {
            console.log(e.response);
        }
    }

    async checkAuth() {
        try {
            if (1){
                const response = await axios.get<AuthResponse>(`${API_URL}/refresh`, {withCredentials: true})
                if (response?.data?.accessToken) {
                    localStorage.setItem('token', response.data.accessToken);
                    this.setAuth(true);
                    this.setUser(response.data.user);
                }
                else this.logout();
            }
        } catch(e:any) {
            console.log(e);
        } finally {
            this.setLoaded(true);
        }
    }

    async refreshUser() {
        try {
            const response = await UserService.refreshUser()
            this.setUser(response.data.user)
        } catch (e:any) {
            console.log(e)
        }
    }

    autoRefreshUser() {
        try {
            const intervalMonitor = setInterval(() => {
                if (this.isAuth) this.refreshUser()
            }, 10e3);
            return () => clearInterval(intervalMonitor)
        } catch (e:any) {
            console.log(e)
        }
    }

    async donate({inputValue, isActive, lang}:any) {
        function validateURL(textval:any) {
            const urlregex = /^(ftp|http|https):\/\/[^ "]+$/;
            return urlregex.test(textval);
        }
        try {
            const steamID64 = this.user.steamID64;
            if (isActive === 'telegram') {
                window.open('https://t.me/rusty_life_pay');
                return 'Success'
            }
            const response = await DonateService.donate({steamID64, inputValue, isActive, lang});
            const redirectURL = response.data;
            if (validateURL(redirectURL)) window.open(`${redirectURL}`);
            else console.log('Error. ', redirectURL);
        } catch(e:any) {
            console.log(e.response?.data);
        }
    }

    async profileTransactions() {
        try {
            const response = await UserService.transactions(),
            transactions = response?.data
            this.setTransactionsLoaded(true)
            return transactions
        } catch(e:any) {
            console.log(e.response?.data)
            return (e.response?.data?.error)
        }
    }

    async profileStorage(t:any, language:any) {
        try {
            const response = await UserService.storage(),
            storage = response?.data
            if (storage) {
                storage.forEach((el: any) => {
		    		el.servers = t(`servers.group.${el.servers}`)
                    el.name = language === 'ru' ? el.nameRU : el.nameEN
                    if (el?.duration?.days) {
                        el.name += ` (${t('defaults.time.days', {count: el?.duration?.days})})`
                    }
		    	})
                this.setStorage(storage)
            }
            this.setStorageLoaded(true)

            return storage
        } catch(e:any) {
            console.log(e.response?.data)
            return (e.response?.data?.error)
        }
    }

    async profileTransfer(receiver:string, amount:string) {
        try {
            const response = await UserService.transfers(receiver, Number(amount))
            if (response?.status===200) this.refreshUser()
            return response
        } catch(e:any) {
            return (e.response)
        }
    }

    async refundProduct(id:string) {
        try {
            const response = await UserService.refundProduct(id)
            if (response?.status===200) this.refreshUser()
            return response
        } catch(e:any) {
            return (e.response)
        }
    }

    async unwrapKit(id:string) {
        try {
            const response = await UserService.unwrapKit(id)
            if (response?.status===200) this.refreshUser()
            return response
        } catch(e:any) {
            return (e.response)
        }
    }

    async getUsernameById(steamID64:string) {
        try {
            const {data} = await UserService.getUsernameById(steamID64)
            return data
        } catch(e:any) {
            if (e?.response?.data?.error === 'TRANSFER_RECEIVER_NOT_FOUND') return undefined
            else return (e.response)
        }
    }

    async profilePromocode(promocode:string) {
        try {
            const response = await UserService.promocode(promocode)
            if (response?.status===200) this.refreshUser()
            return response
        } catch(e:any) {
            return (e.response)
        }
    }

    async serversInfo() {
        try {
            const response = await fetch("https://monitoring.rustylifes.com/servers"),
            serversData = await response.json(),
            sortedServers:any[] = Object.values(serversData.filter((s:any) => !s?.openSoon).reduce((x:any[], { serviceData, enabled }: any, index: number) => {
                if (enabled) {
                    if (!x[serviceData.group]) x[serviceData.group] = []
                    x[serviceData.group].push(serversData[index])
                }
                return x
            }, {}));
            this.setServers(sortedServers);
            this.setServersLoaded(true);            
        } catch (e:any) {
            console.log(e)
        }
    }

    async getDepositBonuses() {
        try {
            const response = await ShopService.getDepositBonuses(),
            bonuses = response?.data

            this.setDepositBonuses(bonuses)
            this.setDepositBonusesLoaded(true)
        } catch(e:any) {
            console.log(e.response?.data)
            return (e.response?.data?.error)
        }
    }
    
    async getKits() {
        try {
            const response = await ShopService.getKits(),
            kits:any = response?.data
            kits.sort((a:any, b:any) => parseFloat(a.order) - parseFloat(b.order));

            const groupedKits = kits.reduce(function(memo:any, x:any) {
                if (!memo[x['servers']]) { memo[x['servers']] = []; }
                x.kits.sort((a:any, b:any) => parseFloat(a?.order) - parseFloat(b?.order))
                memo[x['servers']].push(x);
                return memo;
            }, {});
            
            this.setKits(groupedKits)
            this.setKitsLoaded(true)
        } catch(e:any) {
            console.log(e.response?.data)
            return (e.response?.data?.error)
        }
    }

    async getProducts() {
        try {
            const response = await ShopService.getProducts(),
            products:any = response?.data,
            sortedProducts:any[] = Object.values(products.reduce((x:any[], { servers, enabled }: any, index: number) => {
                if (enabled) {
                    if (!x[servers]) x[servers] = []
                    x[servers].push(products[index])
                }
                return x
            }, {}));
            products.sort((a:any, b:any) => parseFloat(a.order) - parseFloat(b.order));
            this.setProducts(products);
            this.setProductGroups(sortedProducts);
            this.setProductsLoaded(true)
        } catch(e:any) {
            console.log(e.response?.data)
            return (e.response?.data?.error)
        }
    }

    async buyProduct(product:any, plan:any, qnty:number) {
        try {
            if (!this.isAuth) return {data: {status: 400, error: 'PRODUCTS_BUY_UNAUTHORIZED'}}
            const response = await ShopService.buyProduct({product, plan, qnty})
            if (response?.status===200) this.refreshUser()
            return response
        } catch(e:any) {
            return (e.response)
        }
    }

    getUniqueProps (oArray:any, propName:string) {
        const res:any[] = [];
        oArray.forEach((e:any) => {
            res.push(e[propName])
        })
        return Array.from(new Set(res))
    }
}